/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: auto;
`;
